import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  Input,
  useToast,
  keyframes,
  InputLeftAddon,
  InputGroup,
  Text
} from '@chakra-ui/react';
import { HeadingPages } from '../../../components/HeadingPages';
import { useForm, useFieldArray } from 'react-hook-form';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import InputFloating from '../../../components/InputFloating';
import { useEffect, useReducer } from 'react';
import { AiFillPlusCircle } from 'react-icons/ai';
import { IoMdRemoveCircle } from 'react-icons/io';
import { api, baseURL } from '../../../services/api';
import { useQuery } from 'react-query';

const schema = z.object({
  numero_unico: z.string().min(1).max(6, { message: 'Máximo de 6 caracteres' }),
  numero_pedido: z.string().min(1).max(6, { message: 'Máximo de 6 caracteres' }),
  dados_boleto: z.array(
    z.object({
      //retira pontos e virgulas do valor
      valor_documento: z
        .string()
        .min(1, { message: 'Minimo 1 caracteres' })
        //faz os floats serem aceitos com virgula ou ponto
        .regex(/^[0-9]+([,.][0-9]{1,2})?$/, { message: 'Valor inválido' }),

      numero_unico: z
        .string()
        .min(1, { message: 'Minimo 1 caracteres' })
        .max(6, { message: 'Máximo de 6 caracteres' }),
      data_vencimento: z.string().min(1, { message: 'Data de vencimento é obrigatório' }),
      numero_pedido: z
        .string()
        .min(1, { message: 'Minimo 1 caracteres' })
        .max(6, { message: 'Máximo de 6 caracteres' })
    })
  )
});

const initialState = (state, action) => {
  switch (action.type) {
    case 'ADD':
      return [
        ...state,
        { valor_documento: '', numero_unico: '', data_vencimento: '', numero_pedido: '' }
      ];
    case 'REMOVE':
      return state.filter((_, index) => index !== action.payload);

    case 'SAVE':
      return state.map((item, index) => {
        if (index === action.payload.index) {
          return { ...item, [action.payload.field]: action.payload.value };
        }
        return item;
      });

    case 'UPDATE':
      return state.map((item, index) => {
        if (index === action.payload.index) {
          return { ...item, [action.payload.field]: action.payload.value };
        }
        return item;
      });
    case 'RESET':
      return [{ valor_documento: '', numero_unico: '', data_vencimento: '', numero_pedido: '' }];
    default:
      return state;
  }
};

export function GerarBoleto() {
  const [boleto, reducerBoleto] = useReducer(
    initialState,
    [{ valor_documento: '', numero_unico: '', data_vencimento: '', numero_pedido: '' }],
    () => {
      const localBoleto = localStorage.getItem('boleto');
      if (localBoleto) {
        return JSON.parse(localBoleto);
      } else {
        const initialData = [
          { valor_documento: '', numero_unico: '', data_vencimento: '', numero_pedido: '' }
        ];
        localStorage.setItem('boleto', JSON.stringify(initialData));
        return initialData;
      }
    }
  );

  const fadeIn = keyframes`
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    
    to {
      opacity: 1;
      transform: scale(1);
    }
  `;

  const toast = useToast();

  const defaultValues = { dados_boleto: boleto };

  const {
    handleSubmit,
    register,
    watch,
    reset,
    control,
    setError,
    formState: { errors, isSubmitting }
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues
  });

  const { fields, remove } = useFieldArray({
    control,
    name: 'dados_boleto'
  });

  useEffect(() => {
    localStorage.setItem('boleto', JSON.stringify(boleto));
  }, [boleto]);

  function generateDataBoleto() {
    reducerBoleto({ type: 'ADD' });
  }

  const numinno = watch('numero_unico');

  const { data: vlrTotalPedido, isLoading } = useQuery({
    queryKey: ['vlrNota', numinno],
    queryFn: async () => {
      const response = await api.get(`/site/v2/pedido/busca-info-itens-pagamento/${numinno}`);

      const vlrPedido = response.data.map((item) => {
        return {
          valor_nota: item.VALOR_TOTAL_PEDIDO
        };
      });
      //retira do array, colcoa em um objeto e retorna

      return vlrPedido[0];
    },
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 60 * 24,
    enabled: !!numinno && numinno?.length > 5
  });

  //watch nos campos do boleto
  const watchBoleto = watch('dados_boleto');

  // function saveInputBoleto(index, item) {
  //   //salva os valores do input para trazer quando atualizar a página com base no watch
  //   const value = watchBoleto[index]
  //   reducerBoleto({ type: "SAVE", payload: { index, field: "valor_documento", value: value.valor_documento } })
  //   reducerBoleto({ type: "SAVE", payload: { index, field: "numero_unico", value: value.numero_unico } })
  //   reducerBoleto({ type: "SAVE", payload: { index, field: "data_vencimento", value: value.data_vencimento } })
  //   reducerBoleto({ type: "SAVE", payload: { index, field: "numero_pedido", value: value.numero_pedido } })
  // }

  function deleteInputBoleto(index) {
    reducerBoleto({ type: 'REMOVE', payload: index });
    remove(index);
    //deleta os valores do input para trazer quando atualizar a página com base no watch
    // reducerBoleto({ type: "UPDATE", payload: { index, field: "valor_documento", value: "" } })
    // reducerBoleto({ type: "UPDATE", payload: { index, field: "numero_unico", value: "" } })
    // reducerBoleto({ type: "UPDATE", payload: { index, field: "data_vencimento", value: "" } })
    // reducerBoleto({ type: "UPDATE", payload: { index, field: "numero_pedido", value: "" } })
  }

  async function onSubmit(values) {
    //se a data dos boletos forem iguais, retorna erro export const getServerSideRender(props) => {

    const dates = values.dados_boleto.map((item) => item.data_vencimento);

    const uniqueDates = [...new Set(dates)]; //aqui ele pega as datas únicas e compara com o array original

    const valorTotalPedido = parseFloat(vlrTotalPedido.valor_nota);

    const valorTotalBoletos = values.dados_boleto.reduce((acc, item) => {
      return acc + parseFloat(item.valor_documento.replace(',', '.'));
    }, 0);

    if (valorTotalBoletos < valorTotalPedido) {
      toast({
        title: 'Erro',
        position: 'top-right',
        description: 'Valor total dos boletos não pode ser menor que o valor total do pedido',
        status: 'error',
        duration: 9000,
        isClosable: true
      });

      return;
    }

    if (dates.length !== uniqueDates.length) {
      toast({
        title: 'Erro',
        position: 'top-right',
        description: 'Datas de vencimento não podem ser iguais',
        status: 'error',
        duration: 9000,
        isClosable: true
      });

      return;
    }

    try {
      const response = await baseURL.post('/pedido/emite-boleto-nota', {
        ...values,
        dados_boleto: values.dados_boleto.map((item) => {
          return {
            ...item,
            valor_documento: item.valor_documento.replace(',', '.')
          };
        })
      });

      toast({
        title: 'Sucesso',
        position: 'top-right',
        description: 'Boleto gerado com sucesso',
        status: 'success',
        duration: 9000,
        isClosable: true
      });
    } catch (error) {
      console.log(error);
      toast({
        title: 'Erro',
        position: 'top-right',
        description: 'Erro ao gerar boleto, entre em contato com a equipe de desenvolvimento',
        status: 'error',
        duration: 9000,
        isClosable: true
      });
    }

    reducerBoleto({ type: 'RESET' });
    reset();
  }

  return (
    <>
      <HeadingPages name="Gerar boleto" />
      <Flex
        justifyContent="center"
        as="form"
        onSubmit={handleSubmit(onSubmit)}
        flexDir="column"
        mt="2rem"
        maxW="980px"
        mx="auto"
        mb="2rem">
        <Flex flex={1} gap={2} mb=".3rem">
          <InputFloating label="Número único" {...register('numero_unico')} />
          <InputFloating label="Número do pedido" {...register('numero_pedido')} />
        </Flex>
        <Flex gap={2} paddingBlock="1rem" paddingInline=".5rem" flexDir="column">
          <Flex gap={2} flexDir="column">
            {boleto?.map((item, index) => (
              <Box
                paddingBlock="1rem"
                paddingInline=".5rem"
                bgColor="#e2e8f0"
                key={index}
                animation={`${fadeIn} .3s ease-in-out`}>
                <Box
                  bgColor="#f4f5f5"
                  paddingBlock=".2rem"
                  paddingInline=".5rem"
                  borderRadius="5px"
                  width="fit-content"
                  mt="1rem"
                  mb=".5rem"
                  fontSize="11px"
                  textTransform="uppercase"
                  letterSpacing="1px">
                  Parcela
                  <Text
                    as="span"
                    fontWeight="bold"
                    w="15px"
                    h="15px"
                    borderRadius="50%"
                    display="inline-flex"
                    alignItems="center"
                    justifyContent="center"
                    bgColor="#378bbf"
                    color="white">
                    {index + 1}
                  </Text>
                </Box>
                <Box width="100%" height="2px" bgColor="#cecece" />
                <Flex key={index} gap={2} position="relative">
                  <Box position="absolute" top="50%" transform="translateY(-50%)" right="-2rem">
                    <Icon
                      as={IoMdRemoveCircle}
                      mt="2rem"
                      size={30}
                      color="red.500"
                      cursor="pointer"
                      onClick={() => deleteInputBoleto(index)}
                    />
                  </Box>
                  <FormControl isInvalid={errors?.dados_boleto?.[index]?.numero_unico}>
                    <FormLabel>Número único</FormLabel>
                    <Input
                      bgColor="#f4f5f5"
                      placeholder="Número único"
                      {...register(`dados_boleto[${index}].numero_unico`, { required: true })}
                    />
                    <FormErrorMessage>
                      {errors?.dados_boleto?.[index]?.numero_unico &&
                        errors?.dados_boleto?.[index]?.numero_unico?.message}
                    </FormErrorMessage>
                  </FormControl>
                  <FormControl isInvalid={errors?.dados_boleto?.[index]?.numero_pedido}>
                    <FormLabel>Número do pedido</FormLabel>
                    <Input
                      bgColor="#f4f5f5"
                      placeholder="Número do pedido"
                      {...register(`dados_boleto[${index}].numero_pedido`, {
                        required: true
                      })}
                    />
                    <FormErrorMessage>
                      {errors?.dados_boleto?.[index]?.numero_pedido &&
                        errors?.dados_boleto?.[index]?.numero_pedido?.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors?.dados_boleto?.[index]?.valor_documento}>
                    <FormLabel>Valor documento</FormLabel>
                    <InputGroup>
                      <InputLeftAddon children="R$" />
                      <Input
                        bgColor="#f4f5f5"
                        placeholder="Valor documento"
                        {...register(`dados_boleto[${index}].valor_documento`, {
                          required: true
                        })}
                      />
                    </InputGroup>
                    <FormErrorMessage>
                      {errors?.dados_boleto?.[index]?.valor_documento &&
                        errors?.dados_boleto?.[index]?.valor_documento?.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors?.dados_boleto?.[index]?.data_vencimento}>
                    <FormLabel>Data de vencimento</FormLabel>
                    <Input
                      bgColor="#f4f5f5"
                      type="date"
                      {...register(`dados_boleto[${index}].data_vencimento`, {
                        required: true
                      })}
                    />
                    <FormErrorMessage>
                      {errors?.dados_boleto?.[index]?.data_vencimento &&
                        errors?.dados_boleto?.[index]?.data_vencimento?.message}
                    </FormErrorMessage>
                  </FormControl>

                  {/* <Button onClick={() => saveInputBoleto(index, item)} width="120px" disabled={item.saved} mt="2rem">
                    Salvar
                  </Button> */}
                </Flex>
              </Box>
            ))}
          </Flex>

          <Flex
            cursor="pointer"
            color="#378bbf"
            alignItems="center"
            gap={2}
            alignSelf="end"
            onClick={generateDataBoleto}>
            Adicionar mais parcelas <AiFillPlusCircle size={20} />
          </Flex>
        </Flex>
        <Button
          bgColor="#378bbf"
          _hover={{ filter: 'brightness(0.9)' }}
          type="submit"
          isLoading={isSubmitting}
          mt="1rem"
          alignSelf={'flex-end'}
          color="white">
          Gerar boleto
        </Button>
      </Flex>
    </>
  );
}
